// ProcessedHtml.js
import React, { useEffect, useState } from 'react';
import writtenNumber from "written-number";
import axios from 'axios';

const AmountInWords = (amount, language) => {
  const pounds = Math.floor(amount);
  const pence = Math.round((amount - pounds) * 100);

  const languageMap = {
    english: 'en',
    spanish: 'es',
    french: 'en', // fallback to English
    hindi: 'en',
    arabic: 'en',
    german: 'de'
  };

  const langCode = languageMap[language] || 'en';

  const euroWords = writtenNumber(pounds, { lang: langCode });
  const centWords = writtenNumber(pence, { lang: langCode });

  if (language === 'french') {
    return `${capitalize(euroWords)} pounds et ${capitalize(centWords)} centimes`;
  } else if (language === 'spanish') {
    return `${capitalize(euroWords)} pounds y ${capitalize(centWords)} centavos`;
  } else if (language === 'german') {
    return `${capitalize(euroWords)} Euro und ${capitalize(centWords)} Cent`;
  } else {
    return `${capitalize(euroWords)} pounds and ${capitalize(centWords)} pence`;
  }
};


const capitalize = (sentence) =>
  sentence.charAt(0).toUpperCase() + sentence.slice(1);


const ProcessedHtml = ({ clientName, language, ProductCount, onGrandTotal}) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [html, setHtml] = useState('');
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState({});
  const [websiteurl, setWebsiteUrl] = useState("");
  const formattedDate = (date) => new Date(date).toLocaleDateString(); 
  const finalProductCount = ProductCount || 3;

useEffect(() => {
  const handleUpdate = () => { setRefreshKey(prev => prev + 1); };
  window.addEventListener("ratingUpdated", handleUpdate);
  return () => {window.removeEventListener("ratingUpdated", handleUpdate);  };
}, []);

useEffect(() => {
  const handler = async (e) => {
    if (e.target.classList.contains('show-tip-btn')) {
      const title = e.target.getAttribute('data-title');
      if (title) {
        // Find the specific tips container in the same product block
        const tipContainer = e.target.parentElement.querySelector('#tips-container');
        if (!tipContainer) return;

        tipContainer.textContent = "Loading tips...";
        try {
          const response = await axios.post('/api/generate-tips', { title });
          tipContainer.textContent = response.data.tips;
        } catch (error) {
          tipContainer.textContent = "Error fetching tips.";
          console.error(error);
        }
      }
    }
  };
  document.addEventListener('click', handler);
  return () => {
    document.removeEventListener('click', handler);
  };
}, []);

  useEffect(() => {
    const fetchHTML = async () => {
      const res = await fetch(`/invoice/client/${clientName}/content/${language}/invoice.html`);
      const htmlText = await res.text();
      setHtml(htmlText);
    };

    const fetchProducts = async () => {
      const res = await fetch(`/invoice/client/${clientName}/products/products.json`);
      const json = await res.json();

      const allProducts = json.products;
      const settings = json.config?.product_table_settings || {};
      const websiteurl = json.config?.website_url || "";

      //const shuffled = [...allProducts].sort(() => 0.5 - Math.random());
      let neededProducts = [];
      
      while (neededProducts.length < finalProductCount) {
        const remaining = finalProductCount - neededProducts.length;
        const sample = [...allProducts].sort(() => 0.5 - Math.random()).slice(0, remaining);
      
        neededProducts = neededProducts.concat(sample.map((product) => ({
          ...product,
          quantity: Math.floor(Math.random() * 2) + 1,
        })));
      }

      setProducts(neededProducts);
      setSettings(settings);
       setWebsiteUrl(websiteurl); 
    };

    fetchHTML();
    fetchProducts();
  }, [clientName, language, finalProductCount]);

  const getProductRows = () => {
    const taxPercentage = parseFloat(settings.tax_percentage || 0);
    const discountPercentage = parseFloat(settings.discount_percentage || 0);

    return products.map((product, idx) => {
      const savedRatings = JSON.parse(localStorage.getItem("productRatings")) || {};
      const ratingData = savedRatings[product.title[language]];
const stars = ratingData? "<span class='text-warning'>★</span>".repeat(ratingData.rating) + "<span class='text-secondary opacity-25'>★</span>".repeat(5 - ratingData.rating): "";
//const stars = ratingData? "<span class='text-warning'>★</span>".repeat(ratingData.rating) + "<span class='text-secondary-light opacity-25'>☆</span>".repeat(5 - ratingData.rating): "";
      const price = product.price;
      const quantity = product.quantity;
      const tax = settings.tax === 'show' ? `${taxPercentage}%` : '';
      const discount = settings.discount === 'show' ? `${discountPercentage}%` : '';
      const base = price * quantity;
      const discountValue = base * (discountPercentage / 100);
      const taxValue = (base - discountValue) * (taxPercentage / 100);
      const total = (base - discountValue + taxValue).toFixed(2);

      return `
      <tr class="d-none product-mobile-title"><td class="product-name h6">${product.title[language]}</td></tr>
      <tr>
        ${settings.image === 'show' ? 
          `<td class="product-img text-start"><a class="xd-block xm-1" href="${websiteurl}${product.link}" target="_blank"><img src="/invoice/client/${clientName}/${product.image}" alt="${product.title[language]}" /></a></td>` : ''}        
        <td class="product-name text-start">
          <a class="hover-underline" href="${websiteurl}${product.link}" target="_blank">
          ${product.title[language]}
        </a>
            <a class="d-none d-sm-inline-block rating-btn rating-icon hide-in-pdf py-1 secondary-svg  " href="#" data-bs-toggle="modal" data-bs-target="#ratingModal"
              data-title="${product.title[language]}" 
              data-image="/invoice/client/${clientName}/${product.image}">
              ${stars ? `<span class="ms-2 fs-4">${stars}</span>` : 
             '<svg xmlns="http://www.w3.org/2000/svg" class="opacity-50 hover-opacity-100" width="20px" height="20px"  viewBox="0 0 24 24"><title>star-plus</title><path d="M5.8 21L7.4 14L2 9.2L9.2 8.6L12 2L14.8 8.6L22 9.2L18.8 12H18C14.9 12 12.4 14.3 12 17.3L5.8 21M17 14V17H14V19H17V22H19V19H22V17H19V14H17Z" /></svg>'
            }
              
              </a>              
          </span>
        </td>
        ${settings.sku === 'show' ? `<td data-label="SKU">${product.sku}</td>` : ''}
        <td data-label="Unit Price">${price}</td>
        <td data-label="QTY">${quantity}</td>
        ${settings.tax === 'show' ? `<td data-label="Tax">${tax}</td>` : ''}
        ${settings.discount === 'show' ? `<td data-label="Discount">${discount}</td>` : ''}
        <td data-label="CO2" class="carbon Xhighlight text-nowrap px-1">${product.co2} kg</td>
        <td data-label="Item Total" class="product-price text-nowrap">£ ${total}</td>
        <td data-label="Rating" class="d-sm-none">
          ${
            stars
              ? `<span class="text-warning">${stars}</span>`
              : `<a class="d-inline-block rating-btn hide-in-pdf bg-dark border-0 py-1 text-white"
                  href="#"
                  data-title="${product.title[language]}" 
                  data-image="/invoice/client/${clientName}/${product.image}">
                  Add Rating
                </a>`
          }
        </td>
      </tr>`;
    }).join('');
  };

/*   const getMobileRows = () => {
    const taxPercentage = parseFloat(settings.tax_percentage || 0);
    const discountPercentage = parseFloat(settings.discount_percentage || 0);

    return products.map((product, idx) => {
      const price = product.price;
      const quantity = product.quantity;
      const tax = settings.tax === 'show' ? `${taxPercentage}%` : '';
      const discount = settings.discount === 'show' ? `${discountPercentage}%` : '';
      const total = (price * quantity * (1 + taxPercentage / 100) * (1 - discountPercentage / 100)).toFixed(2);

      return `
      <div class="mob-product-row">
        <div><a class="h6 title" href="${websiteurl}${product.link}" target="_blank">${product.title[language]}</a></div>
        <div class="d-flex align-items-center justify-content-center p-2 gap-3">
          ${settings.image === 'show' ? `<div><a class="hover-underline" href="${websiteurl}${product.link}" target="_blank"><img src="/invoice/client/${clientName}/${product.image}" alt="${product.title[language]}" /></a></div>` : ''}
          <div class="flex-grow-1">
            <div class="mob-pro-right">
              <table>
                <tbody>
                  ${settings.sku === 'show' ? `<tr><td>SKU :</td><td>${product.sku}</td></tr>` : ''}
                  <tr><td>Unit Price :</td><td>${price}</td></tr>
                  <tr><td>QTY :</td><td>${quantity}</td></tr>
                  ${settings.tax === 'show' ? `<tr><td>Tax :</td><td>${tax}</td></tr>` : ''}
                  ${settings.discount === 'show' ? `<tr><td>Discount :</td><td>${discount}</td></tr>` : ''}
                  <tr><td>Item Total :</td><td>${total} £</td></tr>
                  <tr class="rating-row">
                    <td colspan="2" class="p-0">
                      <span class="rating">
                        <a class="ms-0 d-inline-block my-1 my-lg-0 rating-btn" href="#" data-bs-toggle="modal" data-bs-target="#ratingModal"
                          data-title="${product.title[language]}"
                          data-image="/invoice/client/${clientName}/content/${language}/${product.image}">Add Rating</a>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>`;
    }).join('');
  }; */

  
const insertProducts = () => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const today = new Date();
  const langCode =
    language === 'german' ? 'de-DE' :
    language === 'arabic' ? 'ar-EG' :
    language === 'french' ? 'fr-FR' :
    language === 'spanish' ? 'es-ES' :
    language === 'hindi' ? 'hi-IN' : 'en-US';

  const formattedDate = today.toLocaleDateString(langCode, {
    weekday: "long",
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const todayDateEls = doc.querySelectorAll('.today-date');
  todayDateEls.forEach(el => el.textContent = formattedDate);

  const targetDiv = doc.getElementById('dynamic-product');
  if (targetDiv) {
    targetDiv.innerHTML = `
      <div class="product">
        <table class="w-100">
          <thead>
            ${settings.image === 'show' ? `<th>Product</th>` : ''}
            <th class="product-header-name text-start">Name</th>
            ${settings.sku === 'show' ? `<th>SKU</th>` : ''}
            <th>Unit Price</th>
            <th>QTY</th>
            ${settings.tax === 'show' ? `<th>Tax</th>` : ''}
            ${settings.discount === 'show' ? `<th>Discount</th>` : ''}
            <th class="carbon Xhighlight text-nowrap px-1">CO₂e</th>
            <th class="product-header-price">Item Total</th>
          </thead>
          <tbody>
            ${getProductRows()}
          </tbody>
        </table>
      </div>`;
  }

  // Totals Calculation
  const taxPercentage = parseFloat(settings.tax_percentage || 0);
  const discountPercentage = parseFloat(settings.discount_percentage || 0);

  let netTotal = 0;
  let totalTax = 0;
  let totalDiscount = 0;
  let totalCO2 = 0;

  products.forEach(product => {
    const price = product.price;
    const quantity = product.quantity;
    const itemBase = price * quantity;
    const itemDiscount = itemBase * (discountPercentage / 100);
    const itemTax = (itemBase - itemDiscount) * (taxPercentage / 100);

    netTotal += itemBase;
    totalTax += itemTax;
    totalDiscount += itemDiscount;
    totalCO2 += parseFloat(product.co2) * quantity;
  });

  const grandTotal = netTotal + totalTax - totalDiscount;

  // Replace values in parsed HTML (doc)
  const formatEuro = (value) => `£ ${value.toFixed(2)}`;

  const setText = (id, value) => {
    const el = doc.getElementById(id);
    if (el) el.textContent = formatEuro(value);
  };

  setText('net-total', netTotal);
  setText('total-tax', totalTax);
  setText('total-discount', totalDiscount);
  setText('grand-total', grandTotal);
  setText('pay-total', grandTotal);

  // ✅ Send grandTotal to parent (NO hook needed)
  if (onGrandTotal && typeof onGrandTotal === 'function') {
    onGrandTotal(grandTotal);
  }

  const amountWordsEl = doc.getElementById('amount-words');
  if (amountWordsEl) {
    amountWordsEl.textContent = AmountInWords(grandTotal, language);
  }

  const co2Element = doc.getElementById('total-carbon');
  if (co2Element) {
    co2Element.textContent = parseFloat(totalCO2.toFixed(2)).toString();
  }

  const treeElement = doc.getElementById('total-tree');
  if (treeElement) {
    let treeCount = 1;
    if (totalCO2 > 1) {
      const decimalPart = totalCO2 % 1;
      const rounded = decimalPart < 0.5 ? Math.floor(totalCO2) : Math.ceil(totalCO2);
      treeCount = rounded;
    }

    const treeTranslations = {
      english: ['Tree', 'Trees'],
      arabic: ['شجرة', 'أشجار'],
      french: ['Arbre', 'Arbres'],
      german: ['Baum', 'Bäume'],
      spanish: ['Árbol', 'Árboles'],
      hindi: ['पेड़', 'पेड़'],
    };

    const [singularTree, pluralTree] = treeTranslations[language] || ['Tree', 'Trees'];
    treeElement.textContent = `${treeCount} ${treeCount === 1 ? singularTree : pluralTree}`;
  }

  return doc.documentElement.outerHTML;
};


  return (
   <div key={refreshKey} dangerouslySetInnerHTML={{ __html: products.length ? insertProducts() : html }} />
   /* <div dangerouslySetInnerHTML={{ __html: html }} /> */
  );
};

export default ProcessedHtml;
